module.exports = __webpack_public_path__ + "static/media/tech-job-3.e7562878.png";